export default {
  styleOverrides: {
    root: {
      fontFamily: 'inherit',
      fontStyle: 'inherit',
      fontSize: 'inherit'
    }
  }
}
